<template>
	<div
		class="switch"
		:class="[`switch--${color}`, toggleOn ? `switch--on` : `switch--off`]"
	>
		<div class="switch__label switch__label--on">
			<slot name="off"></slot>
		</div>
		<div class="switch__element">
			<div class="switch__toggle"></div>
		</div>
		<div class="switch__label switch__label--off">
			<slot name="off"></slot>
		</div>
	</div>
</template>

<script>
export default {
	data: () => ({
		toggleOn: true,
	}),
	watch: {
		toggle: function() {
			this.toggleOn = this.toggle
		},
	},
	mounted() {
		this.toggleOn = this.toggle
	},
	props: {
		toggle: {
			type: Boolean,
			default: true,
		},
		color: {
			type: String,
			default: 'white',
		},
	},
}
</script>

<style lang="scss">
@import '~guyn';

.switch {
	--height: 64px;
	--width: 114px;
	--border: 4px;
	width: 100%;
	display: flex;
	flex-direction: row;
	flex: 1 100px 1;
	padding: 1rem;

	&__element {
		width: var(--width);
		height: var(--height);
		border: var(--border) solid var(--light-color);
		border-radius: var(--width);
		position: relative;
	}
	&__toggle {
		height: calc(var(--height) - var(--border) * 4);
		width: calc(var(--height) - var(--border) * 4);
		border-radius: 50%;
		background-color: var(--dark-color);
		position: absolute;
		left: 4px;
		top: 4px;
		transform: translateX(0%);
		transition: transform 0.5s ease-in-out;
		.switch--off & {
			transform: translateX(100%);
		}
	}

	&--white {
		--light-color: white;
		--dark-color: white;
	}

	&--blue {
		--light-color: #{$guyn-CloudLight};
		--dark-color: #{$guyn-CloudDark};
	}
	&--yellow {
		--light-color: #{$guyn-YellowLight};
		--dark-color: #{$guyn-YellowDark};
	}
}
</style>
